import type { Tables, TablesInsert, TablesUpdate } from "@/integrations/supabase/types";
import type { ServiceContext } from "@prolarus/shared";
import { apiPost, ApiError } from "@/lib/apiClient";
import { tryCreate, tryDelete, tryGet, tryList, tryUpdate } from "./_shared";

export type TicketItem = Tables<"ticket_items">;
export type TicketItemInsert = Omit<TablesInsert<"ticket_items">, "company_id">;
export type TicketItemUpdate = TablesUpdate<"ticket_items">;

export const ticketItemService = {
  get(id: string) {
    return tryGet<TicketItem>(`/api/ticket-items/${encodeURIComponent(id)}`);
  },
  listByTicket(ticketId: string) {
    return tryList<TicketItem>(`/api/tickets/${encodeURIComponent(ticketId)}/items`);
  },
  create(data: TicketItemInsert, _context: ServiceContext) {
    return tryCreate<TicketItem>("/api/ticket-items", data);
  },
  createBatch(items: TicketItemInsert[], _context: ServiceContext) {
    return tryCreate<TicketItem[]>("/api/ticket-items/batch", items);
  },
  update(
    id: string,
    data: TicketItemUpdate,
    _snapshot: Record<string, unknown>,
    _parentId: string,
    _context: ServiceContext,
  ) {
    return tryUpdate<TicketItem>(`/api/ticket-items/${encodeURIComponent(id)}`, data);
  },
  delete(id: string, _snapshot: Record<string, unknown>, _parentId: string, _context: ServiceContext) {
    return tryDelete(`/api/ticket-items/${encodeURIComponent(id)}`);
  },
  async deleteByTicket(ticketId: string, _context: ServiceContext) {
    try {
      const result = await apiPost<{ success: boolean; changesLogged: boolean; count: number }>(
        `/api/tickets/${encodeURIComponent(ticketId)}/items/delete-all`,
      );
      return { success: result.success, error: null, changesLogged: result.changesLogged };
    } catch (err) {
      const e = err instanceof ApiError ? err : err instanceof Error ? err : new Error(String(err));
      return { success: false, error: e, changesLogged: false };
    }
  },
};
